import React from "react"
import { Button } from "semantic-ui-react"
import { reportPage } from "../config/routesInfo"

export default class SalesReportPage extends React.Component {
  state = {
    o200: false,
    o910: false,
  }

  render() {
    const { history } = this.props
    return (
      <>
        <Button
          content={"200-я форма"}
          onClick={() => {
            history.push(`/${reportPage.path}/200`)
          }}
        />
        <Button
          content={"910-я форма"}
          onClick={() => {
            history.push(`/${reportPage.path}/910`)
            this.setState({ o200: false, o910: true })
          }}
        />

        <Button
          content={"ЭСФ"}
          onClick={() => {
            history.push(`/${reportPage.path}/esf`)
            this.setState({ o200: false, o910: false })
          }}
        />
      </>
    )
  }
}
